import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NiosAddSubject = () => {
  const [niosClassName, setNiosClassName] = useState([]);
  const [niosSubjectName, setNiosSubjectName] = useState("");
  const [reference, setReference] = useState("");
  const [subjectUploadIcon, setSubjectUploadIcon] = useState(null);

  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  // Reset form fields
  const resetForm = () => {
    setNiosClassName([]);
    setNiosSubjectName("");
    setReference("");
    document.getElementById("subject-upload-icon").value = "";
  };

  // Fetch classes data
  const getClasses = () => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        console.log("Classes API Response: ", resp.data);
        setNiosClassName(resp.data); // Ensure resp.data is an array
      })
      .catch((error) => {
        console.error("Error fetching classes: ", error);
        alert("Failed to fetch classes. Please try again.");
      });
  };
  console.log(category);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate class selection
    if (!reference) {
      alert("Please select a class.");
      return;
    }

    const formData = new FormData();
    formData.append("subjectName", niosSubjectName);
    formData.append("niosClassId", reference);
    formData.append("icon", subjectUploadIcon);
    category.forEach((cat) => {
      formData.append("category[]", cat);
    });
    axios
      .post(`${API_BASE_URL}/admin/niosSubject`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((resp) => {
        console.log("Subject Added Response:", resp.data);
        alert("Subject Added Successfully");
        resetForm();
        getClasses();
      })
      .catch((err) => {
        console.error("Error Adding Subject:", err.response?.data || err);
        alert("Error Adding Subject. Please try again.");
      });
  };

  // Navigate to add new subject
  const handleAddNewSubject = () => {
    navigate("/nios-add-subject");
  };

  // Navigate to view all subjects
  const handleViewAllSubjects = () => {
    navigate("/nios-all-subject");
  };

  useEffect(() => {
    getClasses();
  }, []);

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Nios Subject</h5>
          <div className="subjectdiv2">
            <button className="handleNewSubject" onClick={handleAddNewSubject}>
              + Add New Subject
            </button>
            <button className="allSubjects" onClick={handleViewAllSubjects}>
              All Subjects
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Nios Subject Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            {/* Class Name Dropdown */}
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={reference}
                onChange={(e) => setReference(e.target.value)}
                required
              >
                <option value="">-Select Class-</option>
                {niosClassName &&
                  niosClassName.map((classes) => (
                    <option value={classes._id} key={classes._id}>
                      {classes?.className}
                    </option>
                  ))}
              </select>
            </div>

            {/* Subject Name Input */}
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Subject</label>
              </div>
              <input
                type="text"
                placeholder="Enter Subject"
                value={niosSubjectName}
                onChange={(e) => setNiosSubjectName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Select Category</label>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  className="school-class-add-input-tag"
                  value={selectCategory}
                  onChange={(e) => setSelectCategory(e.target.value)}
                >
                  <option value="">-Select Category-</option>
                  <option
                    value="Assignment"
                    disabled={category.includes("Assignment")}
                  >
                    Assignment
                  </option>
                  <option
                    value="Exam_Notes"
                    disabled={category.includes("Exam_Notes")}
                  >
                    Exam Notes
                  </option>
                  <option
                    value="video_section"
                    disabled={category.includes("video_section")}
                  >
                    Video Section
                  </option>
                </select>
                <button
                  type="button"
                  onClick={handleAddCategory}
                  className="btn-s"
                >
                  Add
                </button>
              </div>
            </div>

            {/* Show selected categories with remove option */}
            {category.length > 0 && (
              <div className="selected-categories">
                <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                <ul>
                  {category.map((cat, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {cat.replaceAll("_", " ")}
                      <button
                        type="button"
                        onClick={() => handleRemoveCategory(cat)}
                        style={{
                          marginLeft: "10px",
                          background: "red",
                          color: "white",
                          border: "none",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Upload Icon</label>
              </div>
              <input
                type="file"
                id="subject-upload-icon"
                multiple={false}
                onChange={(e) => {
                  const file = e.target.files[0]; // Access the first file
                  console.log(file);

                  if (file) {
                    setSubjectUploadIcon(file); // Store the file object, not the value
                  }
                }}
              />
            </div>

            {/* Form Buttons */}
            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button className="btn-cancel" type="button" onClick={resetForm}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NiosAddSubject;
